import { JetView } from 'webix-jet';

/**
 * Represents the view for the details of a withdrawal request.
 * Extends the JetView class from webix-jet.
 */
export default class detailsWithdrawalRequestView extends JetView {
    /**
     * Configures the form view for the details of a withdrawal request.
     * @returns {Object} The configuration object for the form.
     */
    config() {
        const _ = this.app.getService('locale')._;
        const main_info = {
            margin: 10,
            rows: [
                {
                    view: 'text',
                    name: 'Id',
                    label: "<span class='icon-drivers-license-o'></span>" + _('Id'),
                    labelPosition: 'top',
                    placeholder: _('Id'),
                    invalidMessage: _('A ID is required'),
                    disabled: true,
                },
                {
                    view: 'text',
                    name: 'Type',
                    label: _('Tipo'),
                    labelPosition: 'top',
                    placeholder: _('Tipo'),
                    disabled: true,
                },
                {
                    view: 'text',
                    name: 'Date',
                    label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'),
                    labelPosition: 'top',
                    placeholder: _('Fecha'),
                    disabled: true,
                },
                {
                    view: 'text',
                    name: 'Amount',
                    label: _('Monto'),
                    labelPosition: 'top',
                    placeholder: _('Monto'),
                    disabled: true,
                },
            ],
        };
        const second_main_info = {
            margin: 10,
            rows: [
                {
                    view: 'textarea',
                    name: 'PaymentSystemName',
                    label: _('Nombre sistema de pago'),
                    labelPosition: 'top',
                    placeholder: _('Nombre sistema de pago'),
                    disabled: true,
                },
            ],
        };
        const left_main = {
            gravity: 3,
            minWidth: 200,
            margin: 10,
            rows: [main_info],
        };
        const rigth_main = {
            gravity: 3,
            minWidth: 200,
            margin: 10,
            rows: [second_main_info],
        };
        const upper_section = {
            multiview: true,
            scroll: true,
            cols: [left_main, { gravity: 1, minWidth: 5 }, rigth_main],
        };
        const upper_section_narrow = {
            padding: 10,
            rows: [main_info, second_main_info],
        };
        const detailsCasino = webix.ui({
            view: 'window',
            move: true,
            id: 'detailsCasino',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    {
                        view: 'label',
                        label: _('Detalles Avanzados'),
                        align: 'center',
                    },
                    {
                        view: 'icon',
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide();
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'form',
                id: 'dtDetails2',
                type: 'clean',
                rows: [upper_section_narrow],
            },
        });
        return {
            view: 'form',
            rows: [screen.width > 500 && screen.height > 500 ? upper_section : { height: 1, width: 0 }],
            rules: {
                fname: webix.rules.isNotEmpty,
            },
        };
    }

    /**
     * Initializes the form and sets up event listeners for selecting a withdrawal transaction detail.
     * @param {Object} form - The form instance.
     */
    init(form) {
        this.on(this.app, 'withdrawTransDetail:select', (person) => {
            if (screen.width > 500 && screen.height > 500) {
                form.setValues(person);
                this.$$('Monto').setValue(webix.i18n.priceFormat(person.Amount));
            } else {
                $$('dtDetails2').setValues(person);
            }
        });
    }
}

// FILE DOCUMENTED
